// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1dd4854","455":"155aef9a","488":"e274f92d","977":"263f2cf3"}[chunkId] + ".chunk.js";
};